export default __webpack_public_path__ + "static/media/nasa.ae8ebf5a.jpg";